module.exports = __webpack_public_path__ + "img/demo_nightclub-400x300.3f66409e.jpg";